import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLabel16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLabel16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m13.653 10.36-3.293 3.293a1 1 0 0 1-1.415 0L3.293 8.001A1 1 0 0 1 3 7.294V3h4.294A1 1 0 0 1 8 3.293l5.652 5.652a1 1 0 0 1 0 1.415M2.586 8.708A2 2 0 0 1 2 7.294V3a1 1 0 0 1 1-1h4.294a2 2 0 0 1 1.414.586l5.652 5.652a2 2 0 0 1 0 2.829l-3.293 3.293a2 2 0 0 1-2.829 0zm3.77-2.975a.623.623 0 1 1-1.246 0 .623.623 0 0 1 1.247 0m1 0a1.623 1.623 0 1 1-3.246 0 1.623 1.623 0 0 1 3.247 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLabel16);
